<template>
  <div class="terms-wrapper container">
    <p>
      Al continuar, acepto los
      <a href="#" class="disable-selection">términos y condiciones</a>
      sobre el tratamiento de datos.
    </p>
  </div>
</template>

<script>
export default {
  name: "TermsWrapper",
  components: {}
};
</script>

<style scoped>
.terms-wrapper {
  font-size: 14px;
  font-family: BentonSansBBVA-Book, Helvetica, Arial, sans-serif;
  color: #696969;
  white-space: normal;
}

.disable-selection {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}

div.container {
  padding: 0;
  margin-bottom: 24px;
  white-space: nowrap;
}

@media screen and (max-width: 420px) {
  div.logo img {
    height: 23px;
  }
  p {
    font-size: 12px;
  }
}
</style>
